// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.red-text {
  font-weight: bold;
  color: var(--ion-color-danger);
}

ion-toggle {
  margin: 0px 18px 0px 2px;
}

ion-thumbnail {
  margin-right: 18px;
  --size: 58px;
}

ion-grid {
  padding: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/quote/quote-email-add-rec-file-modal/quote-email-add-rec-file-modal.page.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,8BAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,YAAA;AACJ;;AAEA;EACI,YAAA;AACJ","sourcesContent":[".red-text {\r\n    font-weight: bold;\r\n    color: var(--ion-color-danger);\r\n}\r\n\r\nion-toggle {\r\n    margin: 0px 18px 0px 2px;\r\n}\r\n\r\nion-thumbnail {\r\n    margin-right: 18px;\r\n    --size: 58px;\r\n}\r\n\r\nion-grid {\r\n    padding: 0px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
